const handleEnterKey = (handleFunc) => (e) => {
    if (e.key === 'Enter' && typeof handleFunc === 'function') {
        handleFunc(e);
    }
};

const handleEnterKeyToClick = (e) => {
    handleEnterKey(() => {
        const self = e.target;
        if (self.click && typeof self.click === 'function') {
            self.click(e);
        }
    })(e);
};

/**
 *
 * @param {React.CreateRef()} targetRef
 */
const focusNearestActiveInput = (targetRef) => {
    const inputFieldTagNames = ['INPUT', 'TEXTAREA', 'BUTTON', 'SELECT'];
    const querySelectorStr =
        'input:not(:disabled), textarea:not(:disabled), button:not(:disabled), select:not(:disabled)';
    try {
        if (inputFieldTagNames.includes(targetRef.current.tagName) && !targetRef.current.disabled) {
            targetRef.current.focus();
        } else {
            const foundInput = targetRef.current.querySelector(querySelectorStr);
            foundInput.focus();
        }
    } catch (e) {
        console.log('focusNearestActiveInput', e);
    }
};

export { handleEnterKey, handleEnterKeyToClick, focusNearestActiveInput };
